import React, { useEffect, useState } from 'react'
import { Container } from './styled'
import { useParams } from 'react-router-dom'
import InternalHeader from '../../general/internalHeader/view'
import VenueListItem from '../venueListItem/view'
import { getVenues } from 'api'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router'
import { defaultVenueImage, defaultAvatar } from '../../../../assets/images/defaults';
import { useProfile } from 'context';
import { getAvatarUrl } from '../../../../api/utils';


const VenueHome = () => {
  const { profile } = useProfile();
  const params = useParams()
  const { slug } = params
  const [venues, setVenues] = useState([])
  const navigate = useNavigate()


  function getVenuesInfo() {
    getVenues(slug).then(r => {
      setVenues(r.venues)
    })
      .catch(console.error)
  }

  function navigateVenue(venue) {    
    navigate(`/venue/${venue?.slug}`);      
    //window.location.href = '/login'
  }

  function headerActionMethod() {
    //console.log('Header action')
  }

  useEffect(() => {
    getVenuesInfo(true)
  }, [])


  const avatar = getAvatarUrl(profile, defaultAvatar);

  return (
    <Container>
      {/* Global toolbar */}
      {/* Community header */}
      <InternalHeader title={'Your spaces'} subtitle={''} avatar={avatar} background={defaultVenueImage} actionTitle='Find spaces' actionMethod={headerActionMethod} />
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {venues?.map((item, index) => (
          <Grid item xs={2} sm={2} md={2} lg={1} key={index}>
            <VenueListItem venue={item} selectVenue={(item) => navigateVenue(item)} />
          </Grid>
        ))}
      </Grid>
      {/* List of communities */}
    </Container>
  )
}

VenueHome.propTypes = {}

export default VenueHome
